import { render, staticRenderFns } from "./Interes_Simple_I_Dos.vue?vue&type=template&id=5722fc86&scoped=true&"
import script from "./Interes_Simple_I_Dos.vue?vue&type=script&lang=js&"
export * from "./Interes_Simple_I_Dos.vue?vue&type=script&lang=js&"
import style0 from "./Interes_Simple_I_Dos.vue?vue&type=style&index=0&id=5722fc86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5722fc86",
  null
  
)

export default component.exports